import { login } from '@/api/auth'

export default {
  namespaced: true,
  state: {
    token: localStorage.getItem('token') || '',
    userInfo: JSON.parse(localStorage.getItem('userInfo') || '{}')
  },
  getters: {
    isLoggedIn: state => !!state.token,
    tenantId: state => state.userInfo.tenantId
  },
  mutations: {
    SET_TOKEN(state, token) {
      state.token = token
      localStorage.setItem('token', token)
    },
    SET_USER_INFO(state, userInfo) {
      state.userInfo = userInfo
      localStorage.setItem('userInfo', JSON.stringify(userInfo))
    },
    LOGOUT(state) {
      state.token = ''
      state.userInfo = {}
      localStorage.removeItem('token')
      localStorage.removeItem('userInfo')
    }
  },
  actions: {
    async login({ commit }, credentials) {
      const res = await login(credentials)
      if (res.data) {
        commit('SET_TOKEN', res.data.token)
        commit('SET_USER_INFO', res.data)
      }
      return res
    },
    logout({ commit }) {
      commit('LOGOUT')
    }
  }
}
